import React, {FC} from "react"
import history from "@irati/utils/history"
import PropTypes from "prop-types"

import Button from "@irati/ui/src/Button"
import {IconTypes} from "@irati/ui/src/Icon"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import tracking from "@irati-tracking/platform"
import styled from "styled-components"
import authentication from "@irati/auth"

const StyledText = styled.span`
  margin-left: ${({theme}) => theme.spacing.one};
`

const HOME_LANDING_PAGE = "/home"
const ADMIN_LANDING_PAGE = "/admin/home"
const PERKS_LANDING_PAGE = "/perks/discover"
const WELLNESS_LANDING_PAGE = "/wellness"
const CELEBRATIONS_LANDING_PAGE = "/recognition/polls"
const MEDICAL_LANDING_PAGE = "/medical/my-medical"
const REWARDS_LANDING_PAGE = "/rewards/categories"

export const PRODUCT_LANDING_PAGES = [
  HOME_LANDING_PAGE,
  ADMIN_LANDING_PAGE,
  PERKS_LANDING_PAGE,
  WELLNESS_LANDING_PAGE,
  CELEBRATIONS_LANDING_PAGE,
  MEDICAL_LANDING_PAGE,
  REWARDS_LANDING_PAGE
]
const WALLET_FALLBACK_URL = "/perks/categories"
const FLEXI_POINTS_WALLET_FALLBACK_URL = `${WALLET_FALLBACK_URL}/flexi-perks`

interface Context {
  apps: {[key: string]: string}
  appPath: string
}

interface Props extends InjectIntl {
  productName: string
}

const NavigationBackButton: FC<Props> = ({formatMessage, productName}, {appPath, apps}: Context) => {
  const {PERKS, RECOGNITION, MEDICAL, WELLNESS, WALLET, REWARDS} = apps

  const getFallbackUrl = (): string => {
    switch (appPath) {
      case PERKS:
        return PERKS_LANDING_PAGE
      case MEDICAL:
        return MEDICAL_LANDING_PAGE
      case WELLNESS:
        return WELLNESS_LANDING_PAGE
      case RECOGNITION:
        return CELEBRATIONS_LANDING_PAGE
      case REWARDS:
        return REWARDS_LANDING_PAGE
      case WALLET: {
        const path = location.pathname
        const isFlexiPointsWallet = authentication.apps("wallet.treatTokens")
        const isTenantOrRewardWallet = path.includes("wallet/reward") || path.includes("wallet/tenant")
        if (isTenantOrRewardWallet) {
          return HOME_LANDING_PAGE
        } else if (isFlexiPointsWallet) {
          return FLEXI_POINTS_WALLET_FALLBACK_URL
        } else {
          return WALLET_FALLBACK_URL
        }
      }
      default:
        return HOME_LANDING_PAGE
    }
  }

  const handleClick = () => {
    tracking.navigationClick({type: "Back Button", product: productName})
    history.replace({
      pathname: getFallbackUrl(),
      state: {
        prevPage: window.location.href
      }
    })
  }

  return (
    <Button id="navigation_back_button" icon={IconTypes.arrowLeft} small onClick={handleClick}>
      <StyledText>{formatMessage({id: "platform.button.back"})}</StyledText>
    </Button>
  )
}

NavigationBackButton.contextTypes = {
  apps: PropTypes.object.isRequired,
  appPath: PropTypes.string.isRequired
}

export default injectIntl(NavigationBackButton)
